var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.notifications.length > 0
    ? _c("li", { staticClass: "dropdown dropdown-notification nav-item" }, [
        _c(
          "a",
          {
            staticClass: "nav-link nav-link-label",
            staticStyle: { color: "#FFF" },
            attrs: { href: "#", "data-toggle": "dropdown" },
            on: {
              click: function ($event) {
                _vm.iconClass = "far fa-bell"
              },
            },
          },
          [
            _c("i", {
              class: _vm.iconClass,
              staticStyle: { "font-size": "1.5em" },
            }),
            _vm._v(" "),
            _vm.notificationCount > 0
              ? _c(
                  "span",
                  { staticClass: "badge badge-pill badge-primary badge-up" },
                  [
                    _vm._v(
                      "\n            " +
                        _vm._s(_vm.notificationCount) +
                        "\n        "
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            staticClass:
              "dropdown-menu dropdown-menu-media dropdown-menu-right ",
          },
          [
            _c("li", { staticClass: "dropdown-menu-header" }, [
              _c("div", { staticClass: "dropdown-header m-0 p-2" }, [
                _c("h3", [
                  _c("span", {
                    model: {
                      value: _vm.notificationCount,
                      callback: function ($$v) {
                        _vm.notificationCount = $$v
                      },
                      expression: "notificationCount",
                    },
                  }),
                  _vm._v(
                    " " + _vm._s(_vm.__("globals.new")) + "\n                "
                  ),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "grey darken-2" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(
                        _vm.__("notifications.headers.member.notifications")
                      ) +
                      "\n                "
                  ),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c("li", [
              _c(
                "div",
                {
                  staticStyle: {
                    "max-height": "23rem",
                    overflow: "hidden",
                    "overflow-y": "scroll",
                  },
                },
                [
                  _c(
                    "ul",
                    {
                      staticClass: "p-0 notificationList",
                      staticStyle: { "list-style": "none" },
                    },
                    _vm._l(_vm.notifications, function (notification, index) {
                      return _c(
                        "li",
                        { key: index, staticClass: "media-list" },
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href:
                                  notification.data.link +
                                  (notification.data.module === "group" ||
                                  notification.data.module === "supplier"
                                    ? "?member-fill=1"
                                    : ""),
                                target: "_blank",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.markAsRead(index)
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "media d-flex align-items-center",
                                },
                                [
                                  _vm._m(0, true),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "w-100" }, [
                                    _c("div", { staticClass: "media-body" }, [
                                      _c("h6", {
                                        staticClass:
                                          "primary media-heading mb-0",
                                        domProps: {
                                          textContent: _vm._s(
                                            notification.data.heading
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("small", [
                                        _c("time", {
                                          staticClass:
                                            "media-meta text-muted mb-05",
                                          domProps: {
                                            textContent: _vm._s(
                                              _vm.ago(notification.created_at)
                                            ),
                                          },
                                        }),
                                      ]),
                                      _vm._v(" "),
                                      _c("small", {
                                        directives: [
                                          {
                                            name: "linkified",
                                            rawName: "v-linkified",
                                          },
                                        ],
                                        staticClass:
                                          "notification-text d-block mt-05",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            notification.data.message
                                          ),
                                        },
                                      }),
                                    ]),
                                    _vm._v(" "),
                                    notification.data.contact_request ===
                                      "yes" &&
                                    notification.type ===
                                      "App\\Notifications\\NewFollowUserNotification"
                                      ? _c(
                                          "div",
                                          { staticClass: "d-flex mt-1" },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-success flex-fill mr-1",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.acceptRequest(
                                                      notification.data
                                                        .username,
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.__("globals.accept")
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-danger flex-fill",
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.declineRequest(
                                                      notification.data
                                                        .username,
                                                      index
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            " +
                                                    _vm._s(
                                                      _vm.__("globals.decline")
                                                    ) +
                                                    "\n                                        "
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                ]
                              ),
                            ]
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "dropdown-menu-footer" }, [
              _c(
                "a",
                {
                  staticClass: "dropdown-item p-1 text-center",
                  on: { click: _vm.markAllAsRead },
                },
                [_vm._v(_vm._s(_vm.__("notifications.mark_all")))]
              ),
            ]),
          ]
        ),
      ])
    : _c("li", { staticClass: "dropdown dropdown-notification nav-item" }, [
        _c(
          "a",
          {
            staticClass: "nav-link nav-link-label",
            staticStyle: { color: "#FFF" },
            attrs: { href: "#", "data-toggle": "dropdown" },
          },
          [
            _c("i", {
              class: _vm.iconClass,
              staticStyle: { "font-size": "1.5em" },
            }),
          ]
        ),
      ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "media-left" }, [
      _c("i", {
        staticClass: "feather icon-check-circle font-medium-5 primary",
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }